const fromStoreOfferByIdQueryToStore = (data)=>{
    if (!data) {
        return null;
    }
    try {
        return data.offers.map((offer)=>{
            const { title , description , url , imageUrl  } = offer;
            return {
                title,
                description: description !== null && description !== void 0 ? description : undefined,
                url: url !== null && url !== void 0 ? url : undefined,
                imageUrl: imageUrl !== null && imageUrl !== void 0 ? imageUrl : undefined
            };
        });
    } catch (e) {
        console.error('Store offer data adapter failed to parse input data correctly.', e, data);
        return null;
    }
};

export { fromStoreOfferByIdQueryToStore };
//# sourceMappingURL=fromStoreOfferByIdQueryToStore.js.map
